import React from 'react';

const KalenderPage: React.FC = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Kalender</h1>
      <p className="text-gray-600">Calendar view will be implemented here.</p>
    </div>
  );
};

export default KalenderPage;
